import React from "react";
import { Outlet } from "react-router-dom";
import { AuthLayout as DsAuthLayout } from "../../sandbox/components";
import styles from "./ds.module.scss";

// Auth pages shell (Figma 895:68768): brand-blue screen with the logo and
// decorative rings from the design system. The previous implementation is
// kept in index_old.tsx.
const AuthLayout = (): JSX.Element => (
  <DsAuthLayout className={styles.fullscreen}>
    <Outlet />
  </DsAuthLayout>
);

export default AuthLayout;
